
import { AdminBanksServices } from '@/services/bank.service'

const state = {
  loading: false,
  dialog: false,
  overlay: false,
  mutasibank: [],
  totalmutasibank: 0
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  getMutasiBank ({ dispatch, commit }, opt) {
    commit('setloading', true)
    localStorage.setItem('mutasibank_opt', JSON.stringify(opt))
    AdminBanksServices.getMutasiBank(opt).then(value => {
      commit('setloading', false)
      commit('setmutasibankdata', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setmutasibankdata (state, s) {
    state.mutasibank = []
    state.mutasibank = s.data.content
    state.totalmutasibank = s.data.totalElements
    state.loading = false
    state.overlay = false
  }
}

export const AdminBankStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
